import { BookingApprovalStatus } from '@/shared/constants/booking/BookingApprovalStatus'
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      hasLocationBookingCreatePermission:
        'auth/hasLocationBookingCreatePermission',
    }),
  },
  methods: {
    isBookingRequest(status) {
      const bookingRequestStatuses = [BookingApprovalStatus.PendingApproval]
      return bookingRequestStatuses.includes(status)
    },
    canActionBookingRequest(status, locationId) {
      return (
        this.isBookingRequest(status) &&
        this.hasLocationBookingCreatePermission(locationId)
      )
    },
  },
}
